import api from "./api";
import { API_ENDPOINTS } from "../utils/constants";

export const fetchCountsService = {
  getCounts: async (params = {}) => {
    try {
      const countResponse = await api.get(API_ENDPOINTS.FETCHINGCOUNTS);
      return countResponse;
    } catch (error) {
      throw error;
    }
  },
};
